import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
export const SparkflowLoader = ({ className, message, color, }) => (React.createElement(React.Fragment, null,
    React.createElement(LoadingIndicator.Global, { className: className },
        React.createElement("div", { "data-testid": "loading" })),
    React.createElement(Typography, { variant: "h4", color: color }, message)));
//# sourceMappingURL=sparkflow-loader.js.map